import type { SingleVersion } from '@atlassian/jira-version-picker/src/common/types.tsx';

export const refineDefaultValue = (defaultValue: unknown): SingleVersion | null => {
	if (
		defaultValue !== null &&
		typeof defaultValue === 'object' &&
		'id' in defaultValue &&
		'name' in defaultValue &&
		(typeof defaultValue.id === 'string' || typeof defaultValue.id === 'number') &&
		typeof defaultValue.name === 'string'
	) {
		return { id: `${defaultValue.id}`, name: defaultValue.name };
	}
	return null;
};
